import { FC } from 'react';
import Button from '../button/button';
import Close from '../../assets/close.png';
import { GeneralModalProps } from './modal.type';
import BackIcon from '../../assets/back.svg';
import ButtonSpinner from '../../assets/buttonLoading/buttonLoading';
import './style.css';

const GeneralModal: FC<GeneralModalProps> = ({
  onClose,
  onContinue,
  onSkip,
  onGoBack,
  header,
  headerTitle,
  headerStyle = '',
  headerTitleStyle = '',
  body,
  bodyStyle = '',
  footer,
  footerStyle = 'flex flex-col px-8 ',
  continueText = 'Continue',
  skipText = 'Skip',
  finishText = 'Finish',
  modalClassName = '',
  showBackButton = false,
  continueButtonDisabled = false,
  onFinish,
  isLoading = false,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center generalModalCLass bg-opacity-40`}
    >
      <div
        className={`bg-white rounded-xl shadow-lg w-[42rem] min-h-[30rem] max-h-[90vh] px-[3rem] flex flex-col ${modalClassName}`}
      >
        {/* Header */}
        {(header || headerTitle) && (
          <div
            className={`relative sticky flex gap-2 items-center justify-center px-0 py-6 border-b ${headerStyle}`}
          >
            {header ? (
              header
            ) : (
              <>
                {showBackButton && (
                  <div className="cursor-pointer" onClick={onGoBack}>
                    <img src={BackIcon} alt="Back Arrow" className="w-5 h-5" />
                  </div>
                )}
                {headerTitle && (
                  <div
                    className={`flex-1 text-center font-semibold text-lg ${headerTitleStyle}`}
                  >
                    {headerTitle}
                  </div>
                )}
                {onClose && (
                  <button
                    className="absolute right-4 top-1/2 -translate-y-1/2 p-1"
                    onClick={onClose}
                    disabled={isLoading}
                  >
                    <img src={Close} alt="Close" className="w-4 h-4" />
                  </button>
                )}
              </>
            )}
          </div>
        )}
        {/* Body */}
        <div className="flex flex-col h-full flex-1 overflow-y-auto">
          <div className={`flex-1 px-0 py-6 ${bodyStyle}`}>{body}</div>
          {/* Footer */}
          {(footer || onSkip || onContinue || onFinish) && (
            <div
              className={`f items-center justify-center gap-y-4 py-6 ${footerStyle} `}
            >
              {footer ? (
                footer
              ) : (
                <>
                  {onContinue && (
                    <Button
                      className={`bg-THEME_COLOR text-white rounded-full px-6 py-2 w-[15rem] h-[2.5rem]`}
                      onClick={onContinue}
                      disabled={continueButtonDisabled || isLoading}
                    >
                      {isLoading ? <ButtonSpinner /> : continueText}
                    </Button>
                  )}
                  {onFinish && (
                    <Button
                      className="bg-THEME_COLOR text-white rounded-full px-6 py-2 w-[15rem] h-[2.5rem]"
                      onClick={onFinish}
                      disabled={isLoading}
                    >
                      {isLoading ? <ButtonSpinner /> : finishText}
                    </Button>
                  )}
                  {onSkip && (
                    <Button
                      className="bg-white text-black rounded-full px-6 py-2 w-[15rem] h-[2.5rem] hover:bg-white hover:text-black"
                      onClick={onSkip}
                      disabled={isLoading}
                    >
                      {skipText}
                    </Button>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GeneralModal;
